import { parse, format } from 'date-fns';

export const formatDateTime = (dateString) => {
    if (!dateString) return 'Non spécifié';

    try {
        let date;

        if (typeof dateString === 'string' && dateString.match(/^\d{2}-\d{2}-\d{4} \d{2}:\d{2}$/)) {
            // Parser le format DD-MM-YYYY HH:MM
            date = parse(dateString, 'dd-MM-yyyy HH:mm', new Date());
        } else {
            date = new Date(dateString);
        }

        if (isNaN(date.getTime())) {
            return 'Date invalide';
        }

        return format(date, 'dd-MM-yyyy HH:mm');
    } catch (error) {
        console.error('Erreur de formatage de date:', error);
        return 'Format invalide';
    }
};